import { all, call, SagaReturnType, takeEvery, takeLatest } from "redux-saga/effects";

import {
  loadRecommendationsAction,
  createRecommendationAction,
  editRecommendationAction,
  loadCPRecommendationsAction,
  createCPRecommendationAction,
  loadServicesAction,
  createOfferRecommendationAction,
  uploadIconAction,
  loadOfferRecommendationsAction,
  deleteRecommendationAction,
  deleteCPRecommendationAction,
  deleteOfferRecommendationAction, editCPRecommendationAction, editOfferRecommendationAction,
} from "store/recommendations/recommendations.actions";
import {
  createRecommendation,
  loadServices,
  deleteRecommendation,
  editRecommendation,
  createCPRecommendation,
  deleteCPRecommendation,
  uploadIcon,
  loadRecommendations,
  loadCPRecommendations,
  editCPRecommendation,
  createOfferRecommendation,
  loadOfferRecommendations,
  deleteOfferRecommendation,
  editOfferRecommendation,
} from "api/recommendations";

function* loadRecommendationsFlow(action: typeof loadRecommendationsAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof loadRecommendations> = yield call(loadRecommendations, action.payload);
    yield call(loadRecommendationsAction.sagas.resolve, action, {
      items: data['hydra:member'],
      total: data['hydra:totalItems'],
    });
  } catch (e: any) {
    yield call(loadRecommendationsAction.sagas.reject, action, e?.message);
  }
}

function* loadCPRecommendationsFlow(action: typeof loadCPRecommendationsAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof loadCPRecommendations> = yield call(loadCPRecommendations, action.payload);
    yield call(loadCPRecommendationsAction.sagas.resolve, action, {
      items: data['hydra:member'],
      total: data['hydra:totalItems'],
    });
  } catch (e: any) {
    yield call(loadCPRecommendationsAction.sagas.reject, action, e?.message);
  }
}

function* createRecommendationFlow(action: typeof createRecommendationAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof createRecommendation> = yield call(createRecommendation, action.payload);
    yield call(createRecommendationAction.sagas.resolve, action, data);
  } catch (e: any) {
    yield call(createRecommendationAction.sagas.reject, action, e?.response?.data || e?.message || e);
  }
}

function* editRecommendationFlow(action: typeof editRecommendationAction.types.triggerAction) {
  try {
    yield call(editRecommendation, action.payload);
    yield call(editRecommendationAction.sagas.resolve, action, '');
  } catch (e: any) {
    yield call(editRecommendationAction.sagas.reject, action, e?.response?.data || e?.message || e);
  }
}

function* deleteRecommendationFlow(action: typeof deleteRecommendationAction.types.triggerAction) {
  try {
    yield call(deleteRecommendation, action.payload);
    yield call(deleteRecommendationAction.sagas.resolve, action, '');
  } catch (e: any) {
    yield call(deleteRecommendationAction.sagas.reject, action, e?.response?.data || e?.message || e);
  }
}

function* createCPRecommendationFlow(action: typeof createCPRecommendationAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof createCPRecommendation> = yield call(createCPRecommendation, action.payload);
    yield call(createCPRecommendationAction.sagas.resolve, action, data);
  } catch (e: any) {
    yield call(createCPRecommendationAction.sagas.reject, action, e?.response?.data || e?.message || e);
  }
}

function* deleteCPRecommendationFlow(action: typeof deleteCPRecommendationAction.types.triggerAction) {
  try {
    yield call(deleteCPRecommendation, action.payload);
    yield call(deleteCPRecommendationAction.sagas.resolve, action, '');
  } catch (e: any) {
    yield call(deleteCPRecommendationAction.sagas.reject, action, e?.response?.data || e?.message || e);
  }
}

function* editCPRecommendationFlow(action: typeof editCPRecommendationAction.types.triggerAction) {
  try {
    yield call(editCPRecommendation, action.payload);
    yield call(editCPRecommendationAction.sagas.resolve, action, '');
  } catch (e: any) {
    yield call(editCPRecommendationAction.sagas.reject, action, e?.response?.data || e?.message || e);
  }
}

function* loadServicesFlow(action: typeof loadServicesAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof loadServices> = yield call(loadServices, action.payload);
    yield call(loadServicesAction.sagas.resolve, action, data);
  } catch (e: any) {
    yield call(loadServicesAction.sagas.reject, action, e?.message);
  }
}

function* createOfferRecommendationFlow(action: typeof createOfferRecommendationAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof createOfferRecommendation> = yield call(createOfferRecommendation, action.payload);
    yield call(createOfferRecommendationAction.sagas.resolve, action, data);
  } catch (e: any) {
    yield call(createOfferRecommendationAction.sagas.reject, action, e?.response?.data || e?.message || e);
  }
}

function* loadOfferRecommendationsFlow(action: typeof loadOfferRecommendationsAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof loadOfferRecommendations> = yield call(loadOfferRecommendations, action.payload);
    yield call(loadOfferRecommendationsAction.sagas.resolve, action, {
      items: data['hydra:member'],
      total: data['hydra:totalItems'],
    });
  } catch (e: any) {
    yield call(loadOfferRecommendationsAction.sagas.reject, action, e?.message);
  }
}

function* deleteOfferRecommendationFlow(action: typeof deleteOfferRecommendationAction.types.triggerAction) {
  try {
    yield call(deleteOfferRecommendation, action.payload);
    yield call(deleteOfferRecommendationAction.sagas.resolve, action, '');
  } catch (e: any) {
    yield call(deleteOfferRecommendationAction.sagas.reject, action, e?.response?.data || e?.message || e);
  }
}

function* editOfferRecommendationFlow(action: typeof editOfferRecommendationAction.types.triggerAction) {
  try {
    yield call(editOfferRecommendation, action.payload);
    yield call(editOfferRecommendationAction.sagas.resolve, action, '');
  } catch (e: any) {
    yield call(editOfferRecommendationAction.sagas.reject, action, e?.response?.data || e?.message || e);
  }
}

function* uploadIconFlow(action: typeof uploadIconAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof uploadIcon> = yield call(uploadIcon, action.payload);
    yield call(uploadIconAction.sagas.resolve, action, data);
  } catch (e: any) {
    yield call(uploadIconAction.sagas.reject, action, e?.message);
  }
}

export default function* recommendationsSaga() {
  yield all([
    takeLatest(loadRecommendationsAction.trigger, loadRecommendationsFlow),
    takeEvery(createRecommendationAction.trigger, createRecommendationFlow),
    takeEvery(deleteRecommendationAction.trigger, deleteRecommendationFlow),
    takeEvery(editRecommendationAction.trigger, editRecommendationFlow),
    takeLatest(loadCPRecommendationsAction.trigger, loadCPRecommendationsFlow),
    takeEvery(createCPRecommendationAction.trigger, createCPRecommendationFlow),
    takeEvery(deleteCPRecommendationAction.trigger, deleteCPRecommendationFlow),
    takeEvery(editCPRecommendationAction.trigger, editCPRecommendationFlow),
    takeLatest(loadServicesAction.trigger, loadServicesFlow),
    takeEvery(createOfferRecommendationAction.trigger, createOfferRecommendationFlow),
    takeLatest(loadOfferRecommendationsAction.trigger, loadOfferRecommendationsFlow),
    takeEvery(deleteOfferRecommendationAction.trigger, deleteOfferRecommendationFlow),
    takeEvery(editOfferRecommendationAction.trigger, editOfferRecommendationFlow),
    takeEvery(uploadIconAction.trigger, uploadIconFlow),
  ]);
}